import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1200px) {
    width: 100%;
    justify-content: center;
    display: block;
  }
`;

export const NumberRegistersArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  @media (max-width: 1200px) {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .ant-pagination {
    display: flex;
    padding: 0 1rem;

    @media (max-width: 800px) {
      padding: 0;
    }
  }
/*
  .ant-select {
     margin: 0 1rem;

    @media (max-width: 900px) {
      padding: 0;
      margin-top: 0.5rem;
    }
  } */

  .ant-pagination-item-active a,
  .ant-pagination-item,
  .ant-pagination-item a,
  .ant-select,
  .ant-pagination-prev svg,
  .ant-pagination-next svg,
  .ant-select-arrow svg,
  .ant-pagination-item:focus a {
    color: ${({ corTituloGrid }) => `${corTituloGrid}`};
  }

  .ant-pagination-item-active,
  .ant-pagination-item:hover,
  .ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  .ant-pagination-item:focus {
    border-color: ${({ corTituloGrid }) => `${corTituloGrid}`};
  }

  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a,
  .ant-pagination-item:hover a,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    border-color: ${({ corTituloGrid }) => `${corTituloGrid}`};
    color: ${({ corTituloGrid }) => `${corTituloGrid}`};
  }

  @media (max-width: 795px) {
    width: 100%;
    justify-content: center;

    .ant-select {
      width: 100%;
      margin: 5px auto;
    }
  }

  @media (max-width: 700px) and (min-width: 545px) {
    .ant-select {
      width: 100%;
    }
  }

  .ant-select-selection--single .ant-select-selection__rendered {
    margin-right: 30px;
  }
`;

export const ButtonsArea = styled.div`
  display: flex;
  padding: 0.25rem;
  justify-content: center;

  .ant-typography {
    color: ${({ corTituloGrid }) => `${corTituloGrid}`};
  }

  @media (max-width: 700px) {
    width: 100%;
    justify-content: center;
  }
`;

export const UltimaAtualizacaoArea = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  font-size: ${({ theme }) => `${12 + 2 * theme.zoomFonte}px`};
  padding: 0.25rem;

  @media (max-width: 1200px) {
    display: block;
    text-align: center;
  }


  .title {
    font-weight: bold;
    margin-top: auto;
    margin-bottom: auto;
    text-align: center;

    @media (max-width: 1200px) {
      width: 100%;
      padding: 0.5rem 0.25rem 0;
    }
  }

  .dates {
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    margin-bottom: auto;

    @media (max-width: 1200px) {
      justify-content: center;
      width: 100%;
    }

    p {
      margin-bottom: 0;
      padding: 0.25rem;
    }
  }
`;
